import { endpoint } from "../../../../../views/pages/manage/common/constant";
import { fetchAllPostPromisedData } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const getInitRectRefundReq = ({
    selectedStudent,
    rectRefundStep2Data,
    rectRefundStep3Data,
    refundType,
    additionalStudentDetails
}) => {
    debugger
    const {
        psid,
        applicationId,
        studentName,
        businessAreaDispVal,
        businessArea,
        termDispVal,
        term,
        academicGroupDispValue,
        academicGroup,
        courseId,
        academicCareerValue,
        cashierOffice,
    } = selectedStudent;

    const { selectedReceipt, refundDetailsForm, studentDetailsCorrectionForm, } = rectRefundStep2Data;

    // const {securityCourseId} = additionalStudentDetails;

    const {
        rectificationReason,
        remarks,
        attachmentKey = null,
        paymode
    } = refundDetailsForm;

    const {
        psid: correctPsid,
        applicationId: correctApplicationId
    } = studentDetailsCorrectionForm;

    const { collectPayment } = rectRefundStep3Data;

    const {
        receiptId = "", 
        paymodeAmount, 
        receiptDate, 
        referenceNumber, 
        itemTypeList, 
        totalReceiptedAmount , 
        courseId : sdCourseId , 
        isMiscCharge,
        paymentModeDetailsId,
        paymentModeDetailsItemTypeId
    } = selectedReceipt;

    return {

        // refundType: refundType?.value,
        orderType: refundType?.value,
        subOrderType: refundType?.value,
        refundAmount : paymodeAmount,
        cashierOffice,
        sdCourseId : isMiscCharge ? sdCourseId : null,
        remark : remarks,

        refundNumber: null, //??
        psid,
        applicationId,
        studentName,
        businessAreaValue: businessAreaDispVal,
        businessArea,
        termValue: termDispVal,
        // academicTermId: term,
        // academicGroup: academicGroupDispValue,
        // academicGroupId: academicGroup,
        regularCourseId: courseId,
        academicCareerValue,
        // academicCareerId : -> to be added in search api,
        orderReasonId: rectificationReason?.value,
        attachments: [{
            documentType: "Attachment",
            s3Key: attachmentKey
        }],

        refundDto: {

            // rectificationReason: rectificationReason?.value,
            // s3Key: attachmentKey,
            remark: remarks,

            paymentMode: paymode?.label,
            paymentModeId: paymode?.value,

            correctPsid,
            correctApplicationId,

            oldReceiptId: receiptId,
            oldReceiptTotalAmount: totalReceiptedAmount,
            oldReceiptNumber : receiptId?.slice(-5),
            oldReceiptDate : receiptDate,
            oldPaymentReferenceNumber : referenceNumber,
            oldReceiptDesc : itemTypeList?.map(i => i?.value)?.join(","),
            newReceiptId: null, 
            newReceiptTotalAmount: null,
            paymentModeDetailsId,
            paymentModeDetailsItemTypeId,

            paymentModeDetails: collectPayment?.map((el) => ({
                ...el,
                referenceNumber: (el?.referenceNumber?.label ?? el?.referenceNumber) || "",
            }))
        }

    }
}


export const initiateRectRefund = async (argsObj) => {
    const req = getInitRectRefundReq(argsObj);
    return fetchAllPostPromisedData(endpoint.refund.createRefund, req);
}